import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  styled,
} from '@mui/material';

const plateformes = [
  {
    title: 'Nos plateformes', 
    links: [
      { 
        name: 'Burundi OPEN DATA', 
        url: 'https://burundi.opendataforafrica.org/',
        description: 'Plateforme de données ouvertes du Burundi  - Accédez aux données statistiques complètes'
      }, 
      { 
        name: 'IMIS Burundi', 
        url: 'http://41.79.224.140/redbdi/',
        description: 'Système intégré de management de l\'information statistique - Données économiques et sociales'
      },
      { 
        name: 'Burundi NADA', 
        url: 'https://insbu.bi/nada/index.php/accueil',
        description: 'Catalogue national de données - Archives et données de recherche officielles'
      },
    ], 
    width: 2 
  }
];

const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  transition: 'transform 0.2s ease-in-out',
  border: `2px solid #0d933a`,
  '&:hover': {
    transform: 'scale(1.05)',
    boxShadow: `0px 6px 15px rgba(13, 147, 58, 0.3)`
  },
}));

const StyledCardActionArea = styled(CardActionArea)({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
});

const StyledCardContent = styled(CardContent)(({ theme }) => ({
  padding: theme.spacing(3),
  '&:last-child': {
    paddingBottom: theme.spacing(3),
  },
}));

const TitleTypography = styled(Typography)(({ theme }) => ({
  color: '#0d933a', 
  fontWeight: 'bold',
  marginBottom: theme.spacing(2),
}));

const DescriptionTypography = styled(Typography)(({ theme }) => ({
  color: '#555',
  lineHeight: '1.6',
}));

const PlatformNameTypography = styled(Typography)(({ theme }) => ({
  color: '#0d933a',
  fontWeight: 'bold',
  marginBottom: theme.spacing(1),
  '&:hover': {
    color: '#0d933a',
  },
}));

function Data() {
  return (
    <div style={{ backgroundColor: '#fefffe', paddingBottom: '20px', minHeight: '100vh' }}>
      <NavigationBar />
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        <br />  
      </Typography>
      
      <Container maxWidth="lg" style={{ paddingTop: '20px' }}>
        <Typography 
          variant="h4" 
          align="justify" 
          gutterBottom 
          style={{ 
            color: '#0d933a',
            borderBottom: `3px solid #e30b14`,
            paddingBottom: '10px',
            marginBottom: '30px'
          }}
        >
          Plateformes de Données
        </Typography>

        <Typography 
          variant="body2" 
          align="justify" 
          paragraph 
          style={{ 
            fontSize: '1.1rem', 
            color: '#333',
            marginBottom: '40px'
          }}
        >
          Accédez à nos différentes plateformes de données pour explorer les statistiques, 
          indicateurs économiques et informations officielles du Burundi. Ces plateformes 
          offrent un accès complet aux données nationales et facilitent l'analyse et la recherche.
        </Typography>

        <Grid container spacing={3} style={{ marginTop: '20px' }}>
          {plateformes[0].links.map((plateforme, index) => (
            <Grid item xs={12} md={6} lg={4} key={index}>
              <StyledCard>
                <StyledCardActionArea 
                  href={plateforme.url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <StyledCardContent>
                    <PlatformNameTypography variant="h6" component="div">
                      {plateforme.name}
                    </PlatformNameTypography>
                    <DescriptionTypography variant="body2">
                      {plateforme.description}
                    </DescriptionTypography>
                    <Typography 
                      variant="caption" 
                      style={{ 
                        color: '#0d933a', 
                        fontWeight: 'bold',
                        marginTop: '10px',
                        display: 'block'
                      }}
                    >
                      Cliquez pour accéder à la plateforme →
                    </Typography>
                  </StyledCardContent>
                </StyledCardActionArea>
              </StyledCard>
            </Grid>
          ))}
        </Grid>

        {/* Section d'information supplémentaire */}
        <Grid container spacing={3} style={{ marginTop: '40px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
          <Grid item xs={12}>
            <Typography 
              variant="h5" 
              style={{ 
                color:  '#0d933a', 
                marginBottom: '20px'
              }}
            >
              À propos de nos plateformes
            </Typography>
            <Typography variant="body2" style={{ color: '#333', lineHeight: '1.7' }}>
              Nos plateformes de données sont conçues pour fournir un accès transparent aux informations statistiques 
              officielles du Burundi. Que vous soyez chercheur, étudiant, investisseur ou simple citoyen, 
              ces ressources vous permettront de mieux comprendre l'économie et la société burundaise.
            </Typography>
          </Grid>
        </Grid>
      </Container>
      
      <br />
      <br />
      <Footer />
    </div>
  );
}

export default Data;